<template>
  <div class="city-bank__login-form"
       :id="`${loginFormId}-loginForm`">
    <form :action="loginUrl"
          method="post">
      <div class="row g-2 align-items-center justify-content-end">
        <div class="col-7">
          <div class="input-group">
            <span class="input-group-text">
              <svg xmlns="http://www.w3.org/2000/svg"
                   class="heroicon-svg"
                   fill="none"
                   viewBox="0 0 24 24"
                   stroke="currentColor">
                <path stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </span>
            <input type="text"
                   name="user_id"
                   placeholder="Username"
                   class="form-control"
                   autocomplete="off"
                   required />
          </div>
        </div>
        <div class="col-xl-auto col-5 text-start">
          <button type="submit"
                  class="btn btn-primary"
                  v-if="isAvailable">
            Sign In
          </button>
          <a :href="maintenancePageUrl"
             class="btn btn-primary"
             v-if="!isAvailable">
            Sign In
          </a>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
  import { onMounted } from 'vue';
  import { v4 as uuid } from 'uuid';

  export default {
    props: {
      maintenancePageUrl: {
        type: String,
        required: true
      },
      loginUrl: {
        type: String,
        required: true
      },
      available: {
        type: String,
        reqired: true
      }
    },
    setup(props) {
      const loginFormId = uuid();
      const isAvailable = props.available == 'true';

      onMounted(() => {
        const parent = document.getElementById(`${loginFormId}-loginForm`)
        const input = parent.querySelector('.city-bank__login-form .form-control');
        const icon = parent.querySelector('.city-bank__login-form .input-group-text')

        input.addEventListener('focus', () => {
          icon.classList.add('border-dark');
        });

        input.addEventListener('blur', () => {
          icon.classList.remove('border-dark');
        })
      });

      return {
        loginFormId,
        isAvailable
      }
    },
  };
</script>
